import React, { useState, useEffect, useContext } from 'react';
import { useInterval } from 'react-interval-hook';
import { useNavigate } from 'react-router-dom';
import TeacketContext from 'src/context/TeacketContext';
import useBreadcrumb from 'src/hooks/useBreadcrumb';
import TitleBar from 'src/components/layout/TitleBar';
import { Space } from 'antd';
import { BsCupHotFill } from 'react-icons/bs';
import PageSwitch from 'src/components/layout/PageSwitch';
import { pageList } from './Misc/misc';
import PermissionsProvider from 'src/providers/PermissionsProvider';
import DraggableLayoutProvider from 'src/components/layout/DraggableLayoutProvider';
import DraggableLayoutItem from 'src/components/layout/DraggableLayoutItem';
import { LOCAL_STORAGE_KEYS } from 'src/misc/Config';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import { getTicket, getServicesIsMaster } from 'src/api/teacket';
import { useParams } from 'react-router-dom';
import TicketProperties from './Components/TicketProperties';
import TicketConversation from './Components/TicketConversation';
import FullScreenSpin from 'src/components/layout/FullScreenSpin';
import { subscribe } from 'src/api/subscriptions';
import LoaderServicesForTenant from './Components/LoaderServicesForTenant';
import TicketMembers from './Components/TicketMembers';
import S3Uploader from './Components/S3Uploader/S3Uploader';
import TicketHistory from './Components/TicketHistory';
import TicketCustomProperties from './Components/TicketCustomProps/TicketCustomProperties';

//import PropTypes from 'prop-types';

const Ticket = () => {
  const { setBreadcrumb, dropBreadcrumb } = useBreadcrumb();
  const { executeAsyncProcess } = useAsyncProcesses();
  const { resetCurrentTicket, currentTicket, setCurrentTicket, setActiveViewers } = useContext(TeacketContext);
  const { ticketId } = useParams();
  const navigate = useNavigate();

  const componentsGallery = [
    {
      id: 'Properties',
      component: (
        <DraggableLayoutItem title='Properties'>
          <TicketProperties />
        </DraggableLayoutItem>
      ),
      col: 0,
    },
    {
      id: 'Additional Properties',
      component: (
        <DraggableLayoutItem title='Additional Properties'>
          <TicketCustomProperties />
        </DraggableLayoutItem>
      ),
      col: 0,
    },
    {
      id: 'Conversation',
      col: 1,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              {/* <MdOutlineSecurity /> */}
              Conversation
            </Space>
          }
          centered
        >
          <TicketConversation />
        </DraggableLayoutItem>
      ),
    },
    {
      id: 'People',
      component: (
        <DraggableLayoutItem title='People'>
          <TicketMembers />
        </DraggableLayoutItem>
      ),
      col: 2,
    },
    {
      id: 'Files',
      component: (
        <DraggableLayoutItem title='Files'>
          <S3Uploader />
        </DraggableLayoutItem>
      ),
      col: 2,
    },
    {
      id: 'History',
      component: (
        <DraggableLayoutItem title='History'>
          <TicketHistory />
        </DraggableLayoutItem>
      ),
      col: 2,
    },
  ];

  useEffect(() => {
    if (!currentTicket) loadData();

    setBreadcrumb([
      {
        title: 'Green Teacket',
        path: '/teacket',
      },
      {
        title: 'Ticket List',
        path: '/teacket/tickets',
      },
      {
        title: <>Ticket</>,
      },
    ]);

    return () => {
      resetCurrentTicket();
      dropBreadcrumb();
    };
  }, []);

  useInterval(async () => {
    await subscribeToTicket();
  }, 10000);

  const subscribeToTicket = async () => {
    const viewers = await subscribe('ticket', ticketId);
    setActiveViewers(viewers);
  };

  const loadData = async () => {
    await executeAsyncProcess(async () => {
      try {
        const ticket = await getTicket(ticketId);
        console.log('ticket:', ticket);
        const { isMaster } = await getServicesIsMaster(ticket.service_id);
        console.log('isMaster:', isMaster);
        setCurrentTicket(ticket, isMaster);
        await subscribe('ticket', ticketId);
      } catch (error) {
        console.error(error);
        if (error?.toString()?.includes('404')) {
          navigate('/404');
        }
      }
    });
  };

  const [layoutItemsSelector, setLayoutItemsSelector] = useState(null);

  if (!currentTicket) return <FullScreenSpin title='Please wait' subtitle='Loading ticket' />;

  return (
    <PermissionsProvider requiredPermissions={['apps.teacket.view']}>
      <TitleBar
        title={
          <Space className='btn'>
            <BsCupHotFill />
            <div>
              <span className='text-green-800 dark:text-green-200'>Green Tea</span>cket
            </div>
          </Space>
        }
        afterTitleExtras={
          <div>
            <PageSwitch pageList={pageList} label={`Ticket ${currentTicket?.id}`} />
          </div>
        }
      >
        {layoutItemsSelector}
      </TitleBar>
      <LoaderServicesForTenant>
        <DraggableLayoutProvider getLayoutItemsSelector={(layoutItemsSelector) => setLayoutItemsSelector(layoutItemsSelector)} columns={3} mainColumnIndex={1} componentsGallery={componentsGallery} layoutKey={LOCAL_STORAGE_KEYS.layoutTeacketTicket} layoutHiddenKey={LOCAL_STORAGE_KEYS.layoutTeacketTicketHidden} />
      </LoaderServicesForTenant>
    </PermissionsProvider>
  );
};

// Ticket.propTypes = {};

export default Ticket;
